// Mock for react-native-blob-util
const ReactNativeBlobUtil = {
  fs: {
    dirs: {
      DocumentDir: '/documents',
      CacheDir: '/cache',
      MainBundleDir: '/bundle',
      LibraryDir: '/library',
    },
    writeFile: () => Promise.resolve(),
    readFile: () => Promise.resolve(''),
    unlink: () => Promise.resolve(),
    mkdir: () => Promise.resolve(),
    exists: () => Promise.resolve(false),
  },
  config: () => ({
    fetch: () =>
      Promise.resolve({
        data: '',
        respInfo: {},
      }),
  }),
  fetch: () =>
    Promise.resolve({
      data: '',
      respInfo: {},
    }),
  session: () => ({
    dispose: () => Promise.resolve(),
  }),
};

export default ReactNativeBlobUtil;
